<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="1000" >
      <span>{{snackbar_message}}</span>
    </v-snackbar>     
    <v-row v-if="loading" class="pb-3 pt-3px-3">
        <v-col class="text-center">
          <v-progress-linear
            color="info"
            height="5"
            indeterminate
            striped
          ></v-progress-linear>
        </v-col>
    </v-row>
    <v-row v-else class="pl-4 pb-2 mt-1 d-flex justify-center">
      <div class=""  style="max-width:1200px">
        <v-row>
            <div class="text-h5 mb-3">Richiesta Sondaggio...</div>
            <v-col cols="12" class="d-flex justify-center">
              <v-item-group v-model="activeTemplate" mandatory @change="saveWATemplate()">
                <v-item #default="{ active, toggle }" class="float-left mr-10" v-for="(t,ti) in iReviewWATemplates" :key="ti">
                  <v-switch @change="toggle(!active)" :label="t.description" :input-value="active" hide-details ></v-switch>
                </v-item>
                <!--
                <v-item #default="{ active, toggle }" class="float-left mr-10">
                  <v-switch @change="toggle(!active)" label="Con Coupon a Tutti" :input-value="active" hide-details ></v-switch>
                </v-item>
                <v-item #default="{ active, toggle }" class="float-left mr-5">
                  <v-switch @change="toggle(!active)" label="Con Coupon solo con Recensione >" :input-value="active" hide-details ></v-switch>
                </v-item>
                -->
                <v-text-field
                    v-model="minScore"
                    style="max-width:70px"
                    solo
                    :min="0"
                    :max="5"
                    :step=".1"
                    dense
                    reverse
                    type="number"
                    class="pt-3"
                    label="Punteggio"
                ></v-text-field>        
            </v-item-group>
            <div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon fab small class="" @click="dialog_instruction=true">
                      <v-icon color="success" class="mt-5" large>mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span>Info</span>
                </v-tooltip>
            </div>
                
              
            </v-col>
        </v-row>
        <v-row v-if="WATemplateToShow">
            <v-col cols="6" md="6">
              <v-card class="neu-glow">
                <v-card-title class="d-flex justify-center text-uppercase info">{{WATemplateToShow.description}} {{WATemplateToShow.class=='conditionalCoupon'?minScore:''}}</v-card-title>
                  <v-img 
                    max-height="350"
                    :src="'https://ibookrestaurant.com/static/users/pictures/iReviews/'+WATemplateToShow.picture" 
                    :lazy-src="'https://ibookrestaurant.com/static/users/pictures/iReviews/'+WATemplateToShow.picture" >
                  </v-img>
                <p class="ma-3 text-h6 pb-3">{{settings.options.brand +' ' +WATemplateToShow.sentence1}}</p>
                <p class="mx-3 text-h6 pb-3" v-if="WATemplateToShow.class=='yesCoupon'&&WATemplateToShow.sentence2!=''">{{WATemplateToShow.sentence2}}</p>
                <div class="px-4 py-3">
                  <v-btn block color="info">
                    <v-icon
                      class="mr-3"
                      dark
                    >
                      mdi-open-in-new
                    </v-icon>                
                    Esprimi Opinione</v-btn>
                </div>
                <v-fab-transition>
                  <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs" v-on="on"
                          color="error"
                          fab
                          dark
                          absolute
                          top
                          right
                          class="mt-16"
                          @click="openCropper('iReviews',WATemplateToShow.picture)"
                          
                        >
                          <v-icon>mdi-file-replace</v-icon>
                        </v-btn>
                      </template>
                      <span>Cambia Immagine</span>
                  </v-tooltip> 
                </v-fab-transition> 
              </v-card>
              <v-card class="elevation-12 mt-4">
                <v-img 
                  max-height="350"
                  :src="'https://ibookrestaurant.com/static/users/pictures/db/'+settings.options.logoDB" 
                  :lazy-src="'https://ibookrestaurant.com/static/users/pictures/db/'+settings.options.logoDB" >
                </v-img>
                <div class="text-center text-h6">Gentile <span class="text-uppercase font-weight-bold mt-2 text-h6">{{firstName + ' ' +lastName}}</span></div>
                <div class="text-center text-uppercase mt-2 text-h6">Valuta la tua Esperienza</div>
                <template v-for="(e,ei) in reviewElements">
                  <div :key="ei" class="ml-4 pl-6 text-uppercase">{{e.name}}:</div>
                  <v-rating
                    :key="ei"
                    v-model="ratings[ei]"
                    background-color="#ffdc73"
                    color="#FFD700"
                    large
                    empty-icon="mdi-circle-outline"
                    full-icon="mdi-circle"
                    class="pl-6"
                  ></v-rating>
                </template>
                <div class="ml-2 pl-6 text-uppercase">
                  Scrivi una Recensione:
                </div>
                <div>
                  <v-textarea
                    solo
                    color="black"
                    background-color="green lighten-5"
                    label=""
                    class="mx-4 pl-6"
                    hide-details
                  ></v-textarea>              
                </div>
                <div class="px-4 py-3 pl-6">
                  <v-btn block color="info" :disabled="Object.values(ratings).includes(0)">
                    <v-icon
                      class="mr-3"
                      dark
                    >
                      mdi-open-in-new
                    </v-icon>
                    Invia Opinione</v-btn>
                </div>
              </v-card>
              <v-card class="mt-3">
                <v-fab-transition>
                  <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs" v-on="on"
                          color="error"
                          @click="manageSentence4()"
                          fab
                          dark
                          absolute
                          top
                          right
                          class="mt-4"
                        >
                          <v-icon>mdi-text-box-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Modifica Testo</span>
                  </v-tooltip> 
                </v-fab-transition>
                
                <v-card-text class="text-h6" v-if="addFreeTextBottom==0">{{WATemplateToShow.sentence4}}</v-card-text>
                <v-card-text class="text-h6" v-else>
                  <v-text-field
                    autofocus
                    @keyup="saveSentence4()"
                    label="Testo inviata Recensione"
                    placeholder="Testo visualizzato dopo aver inviato la recensione"
                    v-model="WATemplateToShow.sentence4"
                  ></v-text-field>
                </v-card-text>
                <v-card-text class="text-h6" v-if="totRating<minScore&&WATemplateToShow.class=='yesCoupon'">{{WATemplateToShow.sentence3}}</v-card-text>
                <v-card-text class="text-h6" v-if="totRating>=minScore">Clicca nel link per lasciare la recensione su TripAdvisor o Google <span v-if="WATemplateToShow.class!='noCoupon'"> e scopri il COUPON</span></v-card-text>
                <v-card-text v-if="totRating>=minScore">
                  <v-row>
                    <v-col>
                      <v-btn block color="#4285F4">
                        <v-icon
                          class="mr-3"
                          dark
                        >
                          mdi-google
                        </v-icon>
                        Google
                    </v-btn>                  
                    </v-col>
                    <v-col>
                      <v-btn block color="#00AF87">
                        <v-icon
                          class="mr-3"
                          dark
                        >
                          fa-tripadvisor
                        </v-icon>
                        TripAdvisor
                      </v-btn>                  
                    </v-col>
                  </v-row>
              </v-card>
            </v-col>
     
            <v-col cols="6" md="6" v-if="couponTemplate&&iReviewWATemplates[activeTemplate].class!='noCoupon'">
              <v-card-title class="info">{{iReviewWATemplates[activeTemplate].picture?'Modifica Coupon':'Crea Coupon'}}
              <v-spacer></v-spacer>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon fab small class="mr-4" @click="dialog_newItem=true">
                      <v-icon large color="error">{{iReviewWATemplates[activeTemplate].picture?'mdi-file-edit':'mdi-plus-circle'}}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{iReviewWATemplates[activeTemplate].picture?'Modifica Coupon':'Crea Coupon'}}</span>
                </v-tooltip>            
              </v-card-title>
              <v-row class="mt-2">
                <v-col cols="12">
                  <v-card class="neu-glow">
                    <v-card-title class="d-flex justify-center text-uppercase info">Anteprima Coupon</v-card-title>
                    <v-card-text class="text-center info">per {{iReviewWATemplates[activeTemplate].title}} <span v-if="iReviewWATemplates[activeTemplate].class=='conditionalCoupon'">{{minScore}} </span></v-card-text>
                    <v-img 
                      max-height="600"
                      :src="'https://ibookrestaurant.com/static/users/pictures/coupons/'+couponTemplate.picture" 
                      :lazy-src="'https://ibookrestaurant.com/static/users/pictures/coupons/'+couponTemplate.picture" >
                    </v-img>
                    <p class="ma-3 text-h6 pb-3">{{settings.options.brand}}</p>
                    <p class="mx-3 text-h6 pb-3">{{couponTemplate.couponText1}}</p>
                    <p class="ma-3 text-h6 pb-3">Coupon utilizzabile nei giorni di {{couponDaysText}}</p>
                    <p class="ma-3 text-h6 pb-3">Coupon valido fino al {{couponDueDate}}<span v-if="couponTemplate.maxCovers>0">, per un massimo di {{couponTemplate.maxCovers}} persone</span></p>
                    <p class="ma-3 pb-3">Se richiesto, mostra questo QR Code al cameriere </p>
                    <div class="pa-6 d-flex justify-center">
                      <div class="px-4 pb-2 pt-4 d-flex justify-center white" style="max-width:232px">
                        <qrcode-vue :value="QRCodeLink" :size="200" level="L"></qrcode-vue>
                      </div>
                      <!--
                      <v-img 
                        contain
                        max-height="200"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/QR_Code_Example.svg/240px-QR_Code_Example.svg.png" 
                        lazy-src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/QR_Code_Example.svg/240px-QR_Code_Example.svg.png" >
                      </v-img>
                      -->
                    </div>
                  </v-card>              
                </v-col>
              </v-row>
            </v-col>
        </v-row>
      </div>          
    </v-row>

    <v-dialog v-model="dialog_newItem" width="600" v-if="iReviewWATemplates&&activeTemplate>-1">
            <v-card class="elevation-12">
              <v-card-title>
                {{iReviewWATemplates[activeTemplate].picture?'Modifica Parametri Coupon':'Inserisci Parametri Coupon'}}
                <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-6" @click="saveCoupon()">
                  <v-icon color="error">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-tooltip>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" @click="dialog_newItem=false">
                  <v-icon color="info">mdi-close-circle</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>                
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="mt-5 px-10">
                <v-btn block color="info" @click="openCropper('coupons',couponTemplate.picture)">
                  <v-icon
                    class="mr-3"
                    dark
                  >
                    mdi-image-edit
                  </v-icon>
                  {{iReviewWATemplates[activeTemplate].picture?'Modifica Immagine':'Inserisci Immagine'}}
                </v-btn>              
              </v-card-text>
              <v-card-text>
                <div class="text-left pb-2">Testo Coupon</div>
                <v-textarea
                  v-model="couponTemplate.couponText1"
                  solo
                  label=""
                  rows="2"
                  autogrow
                  class="mx-4 neu-glow pa-4"
                  hide-details
                ></v-textarea>               
              </v-card-text>
              <v-card-text>
                <div class="text-left pb-2">Giorni validi</div>
                <v-btn-toggle v-model="couponTemplate.validDoW" multiple active-class="info" class="d-inline-block transparent justify-center d-flex">
                  <v-btn 
                    v-for="(d,di) in dows" :key="di" :value="d.code">
                    {{d.short}}
                  </v-btn>
                </v-btn-toggle>              
              </v-card-text>
              <v-card-text>
                <v-row class="d-flex justify-center">
                  <v-col>
                    <div>Durata Coupon (giorni)</div>
                    <div class="d-flex justify-center">
                      <v-text-field
                        v-model="couponTemplate.duration"
                        style="max-width:120px"
                        solo
                        :min="1"
                        :max="60"
                        :step="1"
                        dense
                        reverse
                        type="number"
                        class="pt-3"
                        label="Durata Coupon"
                      ></v-text-field>
                    </div>                   
                  </v-col>
                  <v-col>
                    <div>Validità Coupon (persone)</div>
                      <v-text-field
                        v-model="couponTemplate.maxCovers"
                        style="max-width:120px"
                        solo
                        :min="0"
                        :max="20"
                        :step="1"
                        dense
                        reverse
                        type="number"
                        class="pt-3"
                        label="Persone"
                    ></v-text-field>                  
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card> 
    </v-dialog>

    <!--
    <v-dialog v-model="dialog_imageChange_info" max-width="400">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Suggerimenti
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_imageChange_info = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1">
                <v-col md="12" cols="12">
                    <p>
                        Si consiglia di ritagliare una immagine quadrata, possibilmente senza sfondo
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
    -->
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card class="neu-glow pa-4">
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-card class="neu-glow pa-4">
              <v-row class="mx-5 mt-1">            
                <v-col md="3" cols="6">
                  Abilita Premio
                </v-col>
                <v-col md="9" cols="6">
                  Abilita o disabilita il premio indipendentemente dai parametri successivi
                </v-col>
                <v-col md="3" cols="6">
                  Giorni Validi
                </v-col>
                <v-col md="9" cols="6">
                  Giorni della settimana validi per spendere il premio.
                  <br>Cambiate il valore e verificate cosa cambia in "Cosa vede il Cliente"
                </v-col>
                <v-col md="3" cols="6">
                  Durata
                </v-col>
                <v-col md="9" cols="6">
                  Giorni entro i quali il premio può essere riscosso
                  <br>Cambiate il valore e verificate cosa cambia in "Cosa vede il Cliente"
                </v-col>
                <v-col md="3" cols="6">
                  Minimo per Google/TA
                </v-col>
                <v-col md="9" cols="6">
                  Somma minima delle stelle ottenute nella valutazione interna (escluso Location) per richiedere la recensione su Google o TripAdvisor
                </v-col>
                <v-col md="3" cols="6">
                  Intervallo Premio
                </v-col>
                <v-col md="9" cols="6">
                  Intervallo della somma di stelle ottenute nella valutazione interna (escluso Location) per offrire il Coupon
                </v-col>
              <v-col md="3" cols="6">
                  Nome Premio
                </v-col>
                <v-col md="9" cols="6">
                  Nome del premio che verrà visualizzato dal Cliente
                  <br><span class="red--text">Specificare la quantità: esempio 1 Bottiglia, oppure 1 Calice <strong>ciascuno</strong></span>
                </v-col>
                <v-col md="3" cols="6">
                  Descrizione del Premio
                </v-col>
                <v-col md="9" cols="6">
                  Descrizione Libera del premio (facoltativa)
                </v-col> 
                <v-col md="3" cols="6">
                  Immagine Premio
                </v-col>
                <v-col md="9" cols="6">
                  Immagine coordinata del premio: si consiglia di ritagliare una immagine quadrata, la dimensione viene automaticamente ridotta a 600x600px
                </v-col>                            
            </v-row>
          </v-card>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_vuecropper" max-width="1100">
      <vuecropper
        ref='crpr' 
        @close="closeCropper"
        @completed="handleCompleted"
        @error="handlerError"
        :uploadFormData="UFD"
      >
      </vuecropper>
    </v-dialog>	    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
import vuecropper from "../VueCropper";
import QrcodeVue from 'qrcode.vue';
export default {
   components: {
      QrcodeVue,
      vuecropper
    },  
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      dialog_vuecropper:false,
      dialog_imageChange_info:false,
      dialog_newItem:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      snackbar:null,
      snackbar_color:null,
      snackbar_message:null,
      allLocations:null,
      clockStep:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      mealId:null,
      tabId:null,
      dowId:null,
      slotId:null,
      subdomain:null,   
      UFD:null,   
      QRCodeLink:'BB560C31F20E418C0A5E2955ECD88FEFED082D42',
      review:{"food":4,"service":4,"value":4,"location":4,"review":null},
      editedItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      emptyItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      dows2:['LUN','MAR','MER','GIO','VEN','SAB','DOM'],
      dows:[
            {code:1,it:'Lunedì',en:'Mondays',"short":"LUN"},
            {code:2,it:'Martedì',en:'Tuesdays',"short":"MAR"},
            {code:3,it:'Mercoledì',en:'Wednsdays',"short":"MER"},
            {code:4,it:'Giovedì',en:'Thursdays',"short":"GIO"},
            {code:5,it:'Venerdì',en:'Fridays',"short":"VEN"},
            {code:6,it:'Sabato',en:'Saturdays',"short":"SAB"},
            {code:7,it:'Domenica',en:'Sundays',"short":"DOM"}
           ],
      headersPromo:[
              {title:"Omaggio",remarks:"Omaggio (per persona) offerto"},
              ],
      allMeals:null,
      sumReviews:16,
      uploadURL:'https://ibookrestaurant.com/ajax/settings/upload.php',
      //coupons:[{"class":"noCoupon","txt":"Senza Coupon"},{"class":"conditionlCoupon","txt":"Coupon Condizionato"},{"class":"yesCoupon","txt":"Sempre Coupon"}],
      cropperOptions:[
                      {dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true},
                      {aspectRatio: 4, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true}
                     ],
      outputOptions: [
                        {
                        width: 600,
                        height: 600,
                        minWidth: 300,
                        minHeight: 300,
                        maxWidth: 900,
                        maxHeight: 900,
                        imageSmoothingEnabled: true,
                        imageSmoothingQuality: 'high',
                      }
                    ],      
      pictureName:null,
      pictureNameW:null,
      pictureNameRoot:null,
      pictureNameRootW:null,
      prize_hash:null,

      timer4:null,
      
      ratings:[0,0,0,0,null],
      lastName:'Rossi',
      firstName:'Mario',
      addFreeTextBottom:0,
      group: 0,
      minScore: null,
      activeTemplate:null,
      saveActiveTemplate:0,
      validity:15,
      covers:3,
      brand:'Farina 44',
      iReviewWATemplates:null,
      couponTemplate:null,
      reviewElements:[{"name":"Cibo"},{"name":"Servizio"},{"name":"Qualità/Prezzo"},{"name":"Location"}],
      /*coupons:[{"couponId":"AB1","class":"noCoupon","title":"Sondaggio Senza Coupon","picture":"https://ibookrestaurant.com/static/users/pictures/slides/farina44_1.jpeg","logo":"https://ibookrestaurant.com/static/users/pictures/db/T1688971854416-Wfarina44.svg","sentence1":"vorrebbe ricevere il tuo feedback","sentence2":"","sentence3":""},
              {"couponId":"CD2","class":"yesCoupon","title":"Sondaggio con Coupon per tutti i Clienti","picture":"https://ibookrestaurant.com/static/users/pictures/slides/farina44_2.jpeg","logo":"https://ibookrestaurant.com/static/users/pictures/db/T1688971854416-Wfarina44.svg","sentence1":"vorrebbe ricevere il tuo feedback","sentence2":"Ricambieremo il favore con un Coupon Omaggio","sentence3":"Riceverai il COUPON OMAGGIO"},
              {"couponId":"EF3","class":"conditionalCoupon","title":"Sondaggio con Coupon con Punteggio > di ","picture":"https://ibookrestaurant.com/static/users/pictures/slides/farina44_3.jpeg","logo":"https://ibookrestaurant.com/static/users/pictures/db/T1688971854416-Wfarina44.svg","sentence1":"vorrebbe ricevere il tuo feedback","sentence2":"","sentence3":"Abbiamo pensato di inviarti un COUPON OMAGGIO"},],
              */



    };
  },
  computed : {
    ...mapGetters(["settings"]),
    totRating: function()
    {
      return this.ratings.reduce((partialSum, a) => partialSum + a, 0)/4
    },
    WATemplateToShow:function()
    {
      return this.iReviewWATemplates[this.activeTemplate];
    },
    couponDueDate:function()
    {
      var r=new Date();
      r.setDate(r.getDate()+this.couponTemplate.duration/1)
      //return r.toLocaleString('it-IT').split(',')[0]
      return new Intl.DateTimeFormat('it').format(r)
    },
    couponDaysText:function()
    {
      console.log(580,this.couponTemplate)
      if (this.couponTemplate)
      {
        return this.dows.filter(d=>this.couponTemplate.validDoW.includes(d.code)).map(a => a.it).join(', ')
      }
      else
      {
        return '';
      }
    }      
  },
  beforeUnmount()
  {
      //alert("leaving")
  },
  created(){
    this.getData();
    this.getData2();
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    minScore(newVal)
    {
      this.iReviewWATemplates[this.activeTemplate].minScore=newVal;
      this.saveWATemplate_minScore()
    }
    /*
    activeTemplate(newVal,oldVal)
    {
      console.log(595,newVal,oldVal,this.saveActiveTemplate)
      if (this.saveActiveTemplate)
      {
        console.log(598,newVal,oldVal)
        this.save2(newVal.class, 'reviewCouponClass', 'User_Options','')
      }
      else
      {
        this.saveActiveTemplate=1;
      }
    }
    */
  },
  methods:
  {
    manageSentence4()
    {
      console.log(636,this.addFreeTextBottom)
      this.addFreeTextBottom==0?this.addFreeTextBottom=1:this.addFreeTextBottom=0;
      console.log(638,this.addFreeTextBottom)
    },
    saveSentence4()
    {
  if (this.timer4) {
          clearTimeout(this.timer4);
          this.timer4 = null;
      }
      this.timer4 = setTimeout(() => {
          this.save2(this.WATemplateToShow.sentence4, 'sentence4', 'User_iReviewWATemplate','')
      }, 1000);
    },
    saveWATemplate_minScore()
    {
      console.log(625,this.minScore)
      this.save2(this.minScore, 'minScore', 'User_iReviewWATemplate','')
    },    
    saveWATemplate()
    {
      var value=this.iReviewWATemplates[this.activeTemplate].class;

      console.log(632,this.activeTemplate,value)
      this.save2(value, 'reviewCouponClass', 'User_Options','')
    },
    save2(value, field, table,slotId='') {
      console.log(636,value, field,this.dowId);
      var pload;     
      if (table=='PBD')
      {
        var dow=this.dows2.findIndex(d=>d==this.dowId)+1
        pload={"parameter":field,"value":value===false?0:value===true?1:value===''?null:value,"slotId":slotId,"dow":dow};
        console.log(411,pload);
        table='AllParametersByDOW_single'
      }
      else
      {
        pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      }
      
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":table,"payload":pload};
      console.log(413,payload)
      let rspns=this.updateDB(payload)
      console.log(rspns)

    },
    openCropper(type,img)
    {
      this.UFD={'name':img,'type':type,'optionId':type,'width':400,'height':400,"subdomain":this.settings.hostnames.subdomain,"iReviewWATemplateId":this.iReviewWATemplates[this.activeTemplate].iReviewWATemplateId }
      console.log(701,this.UFD)
      this.dialog_vuecropper=true;
    },
    closeCropper()
    {
      this.dialog_vuecropper=false;
      this.$refs.crpr.reset();
      this.$refs.crpr.destroy();
      //this.$refs.cropper.reset();
      //this.$refs.cropper.destroy();
      //this.UFD=null;
      //this.UFD={'name':null,'type':null,'optionId':'coupon','width':400,'height':400}
    }, 
    showFileChooser() {
      this.$refs.camera.click();
    },
    handleUploading({ form, request }) {
      // show a loader
      console.log(384, {form, request})
    },
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message='Modificata Immagine';
        this.dialog_vuecropper=false;
        if (response.optionId=='coupons')
        {
          this.couponTemplate.picture=response.pictureName
        }
        else
        {
          console.log(688,response.pictureName)
          console.log(689,this.iReviewWATemplates[this.activeTemplate])
          console.log(690,this.iReviewWATemplates[this.activeTemplate].picture)
          this.iReviewWATemplates[this.activeTemplate].picture=response.pictureName;
          console.log(692,this.iReviewWATemplates[this.activeTemplate].picture)
        }
        //this.activeTemplate.reviewImage=response.pictureName;
        //this.activeTemplate.highRewardImage=response.pictureName;
        //console.log(654,this.iReviewWATemplates[this.activeTemplate],this.couponTemplate)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, message, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },    
    setPictureName(i)
    {
      console.log(648,i);
      //this.pictureType=i.optionId.includes('TB')?'tb':'db';
      this.pictureNameRoot='';
      this.optionId='';
      this.pictureName='';
    },
   addDaysFormatted(days) {
     var result = new Date();
     result.setDate(result.getDate() + days);
     return result.toLocaleDateString( this.settings.locale,{ weekday: 'long',  month: 'long', day: 'numeric' });
   },
   /*
   save: _.debounce(function (event) {
      //this.refreshItem(event.target.name,event.target.value)
      console.log(296,event);
      console.log(297,event.target.name,event.target.value,event.target.id)
      console.log(298,this.dowId,this.mealId,this.activeSlots)
      //console.log(299,this.VMOptions[event.target.name])

      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      console.log(704,this.dow,this.dows)
      //var dow=this.dows.findIndex(d=>d==this.dow.codeId)+1
      var pload={"parameter":event.target.name,"value":value,"slotId":event.target.id,"dow":dow};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(307,payload)
      this.updateDB(payload)
    }, 1000), */
    showItem(i)
    {
      console.log(702,i)
      this.activeTemplate=i;
      //this.sumReviews=i.minimumScore;
      this.prize_hash=JSON.stringify(this.activeTemplate);
    },  
    editItem(f=null)
    {
      if (f) 
      {
        this.editedItem=f;
      }
      else{
        this.editedItem={...this.emptyItem};
        this.editedItem.active=1;
      }
      console.log(214,f)
      this.hash=JSON.stringify(this.editedItem);
      this.dialog_edit=true;
    },
    deleteItem(f)
    {
      this.activeTemplate=f;
      console.log(214,f)
      this.dialog_delete=true;
    },    
    async saveCoupon()
    {
        console.log(760,this.couponTemplate);
        this.loading_update=true;
        //let payload={"action":"saveItem","table":"User_couponTemplates","payloadCoupon":this.couponTemplate,"payloadWA":this.iReviewWATemplates[this.activeTemplate]};
        let payload={"action":"saveItem","table":"User_couponTemplates","payload":{"coupon":this.couponTemplate,"WA":this.iReviewWATemplates[this.activeTemplate]}};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            //this.snackbar_color="success"
            //this.message =w.payloads.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.dialog_newItem=false;
            this.prize_hash=JSON.stringify(this.activeTemplate);
            this.getData('refresh');
            //this.$root.$emit('onupdateLocations', null);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
        //this.editedItem={...this.emptyItem}
    },
    async getData2()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllParameters_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(781,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.loading= false;
                    this.allLocations=res.data.payloads.allLocations;
                    this.allMeals=res.data.payloads.allMeals,
                    this.activeSlots=res.data.payloads.activeSlots;
                    this.activeSlots_hash=JSON.stringify(this.activeSlots);
                    this.tabs=res.data.payloads.allLocations;
                    console.log(792,this.allSlots,this.tabs,this.activeSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },     
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            //try{
                const payload=JSON.stringify({"action":"iReviewWATemplates_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(820,res);
                console.log(821,res.data.errorid)
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                  case '0':
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.iReviewWATemplates=res.data.payloads.iReviewWATemplates;
                      console.log(827,res.data.payloads.activeTemplate.activeTemplate)
                      //this.activeTemplate=this.iReviewWATemplates.find(p=>p.class==res.data.payloads.activeTemplate.activeTemplate)
                      this.activeTemplate=this.iReviewWATemplates.map(e => e.class).indexOf(res.data.payloads.activeTemplate.activeTemplate);
                      this.prize_hash=JSON.stringify(this.activeTemplate);
                      this.minScore=this.iReviewWATemplates.find(t=>t.class=='conditionalCoupon').minScore
                      this.couponTemplate=res.data.payloads.couponTemplate;
                      console.log(832,this.iReviewWATemplates,this.couponTemplate,this.activeTemplate)
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            /*} catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }*/
        }
    },    
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(383,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;
            
            if (res.data.message)
            {
                console.log(392);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(401);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
};
</script>